import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { HaldorBlockEditor } from '@haldor/ui';
import { useTranslate } from 'lib/translate';
import AddAssessmentBlockButton from './Plugins/AddAssessmentBlockButton';
import AddTeacherAssessmentBlockButton_Plugin from './Plugins/AddTeacherAssessmentBlockButton';
import PushAssessmentBlock from './Plugins/PushAssessmentBlock';
import TeacherAssessmentBlock from './Blocks/TeacherAssessmentBlock/TeacherAssessmentBlock';
import SelfAssessmentBlock from './Blocks/SelfAssessmentBlock/SelfAssessmentBlock';
import PeerReviewBlock from './Blocks/PeerReviewBlock/PeerReviewBlock';
import './_AssessmentBlock.scss';
import { ASSESSMENT_TYPES } from './AssessmentTypes';
import { ASSESSMENT_BLOCK_TYPES } from './AssessmentBlockTypes';

var BlockAssessments = function BlockAssessments(props) {
  var _props$input;

  var translate = useTranslate();
  var plugins = [TeacherAssessmentBlock, PeerReviewBlock, SelfAssessmentBlock, PushAssessmentBlock];

  if (props.multipleAssessmentOptions) {
    plugins.push(AddAssessmentBlockButton);
  }

  if (!props.multipleAssessmentOptions) {
    plugins.push(AddTeacherAssessmentBlockButton_Plugin);
  }

  if (((_props$input = props.input) === null || _props$input === void 0 ? void 0 : _props$input.value) != '') {
    var _props$input2, _props$input2$value;

    (_props$input2 = props.input) === null || _props$input2 === void 0 ? void 0 : (_props$input2$value = _props$input2.value) === null || _props$input2$value === void 0 ? void 0 : _props$input2$value.forEach(function (value) {
      if (value.resources != null && value.resources.length > 0) {
        var resource = value.resources.map(function (s) {
          return s.assessmentType;
        })[0];

        switch (resource) {
          case ASSESSMENT_TYPES.PEER:
            value.type = ASSESSMENT_BLOCK_TYPES.PEER_REVIEW_BLOCK;
            break;

          case ASSESSMENT_TYPES.TEACHER:
            value.type = ASSESSMENT_BLOCK_TYPES.TEACHER_ASSESSMENT_BLOCK;
            break;

          case ASSESSMENT_TYPES.SELF:
            value.type = ASSESSMENT_BLOCK_TYPES.SELF_ASSESSMENT_BLOCK;
            break;

          default:
            value.type = ASSESSMENT_BLOCK_TYPES.TEACHER_ASSESSMENT_BLOCK;
            break;
        }
      }
    });
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "assessment-block"
  }, /*#__PURE__*/React.createElement(HaldorBlockEditor, _extends({
    plugins: plugins,
    deregisterPlugins: ['Core_Haldor_Editor_PlaceholderLine', 'Core_Haldor_Block_PushPlaceholder', 'PlaceholderBlock', 'Haldor.Blocks.Editor'],
    translate: translate
  }, props)));
};

BlockAssessments.defaultProps = {
  multipleAssessmentOptions: false
};
export default BlockAssessments;